import * as React from 'react';

export const LazyModeratedRiskPreserveCapital = React.lazy(() => import('./component'));
